import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-bulk-scenes-changes',
    templateUrl: './bulk-scenes-changes.component.html',
    styleUrls: ['./bulk-scenes-changes.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BulkScenesChangesComponent implements OnInit {

  	@Input() selected: any[];
	@Input() scenesList?: any[];
	@Output() onClose = new EventEmitter<any>();
	@Output() onEdit = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();
	@Output() onDelete = new EventEmitter<any>();

	private getScenesListSelected(): any[] {
		return this.scenesList.filter(scene => this.selected.includes(scene.id));
	}

	scenesCannotBeDeleted() {
		const scenesListSelected = this.getScenesListSelected();
		
		return scenesListSelected.some(scene => scene.scene_status_id >= 4);
	}

	close() {
		this.onClose.emit();
	}

	edit() {
		this.onEdit.emit();
	}

	cancel() {
		this.onCancel.emit();
	}

	delete() {
		!this.scenesCannotBeDeleted() && this.onDelete.emit();
	}

	constructor() { }

	ngOnInit(): void {
	}
}
